// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/location.proto (package squareup.common.location, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Country } from "./countries_pb";
import { file_squareup_common_countries } from "./countries_pb";
import { file_squareup_common_pii } from "./pii_pb";
import type { Script } from "./script_pb";
import { file_squareup_common_script } from "./script_pb";
import { file_squareup_common_validation } from "./validation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/location.proto.
 */
export const file_squareup_common_location: GenFile = /*@__PURE__*/
  fileDesc("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", [file_squareup_common_countries, file_squareup_common_pii, file_squareup_common_script, file_squareup_common_validation]);

/**
 * @generated from message squareup.common.location.GeoLocation
 */
export type GeoLocation = Message<"squareup.common.location.GeoLocation"> & {
  /**
   * @generated from field: optional double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: optional double longitude = 2;
   */
  longitude: number;

  /**
   * @generated from field: optional double altitude_meters = 3;
   */
  altitudeMeters: number;

  /**
   * normally used for mobile devices
   *
   * @generated from field: optional double uncertainty_meters = 4;
   */
  uncertaintyMeters: number;
};

/**
 * Describes the message squareup.common.location.GeoLocation.
 * Use `create(GeoLocationSchema)` to create a new message.
 */
export const GeoLocationSchema: GenMessage<GeoLocation> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 0);

/**
 * Geographic coordinates specified in decimal degrees.
 *
 * @generated from message squareup.common.location.Coordinates
 */
export type Coordinates = Message<"squareup.common.location.Coordinates"> & {
  /**
   * @generated from field: optional double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: optional double longitude = 2;
   */
  longitude: number;

  /**
   * *
   * The height in metres the WGS84 ellipsoid. expected to be null if the implementation cannot
   * provide a value. cf. https://en.wikipedia.org/wiki/World_Geodetic_System.
   *
   * @generated from field: optional double altitude = 3;
   */
  altitude: number;

  /**
   * *
   * The accuracy of above coordinates specified in metres. These are expected to correspond to a
   * 95% confidence interval. If this is not supported, values are expected to be null.
   *
   * @generated from field: optional double geographic_accuracy = 4;
   */
  geographicAccuracy: number;

  /**
   * @generated from field: optional double altitudinal_accuracy = 5;
   */
  altitudinalAccuracy: number;

  /**
   * *
   * The direction of travel specified in decimal degrees where 0° ≤ heading ≤ 360°, counting
   * clockwise relative to true north. If this is not supported, the value is expected to be null.
   * If the subject is stationary (speed below is zero), this is expected to be NaN.
   *
   * @generated from field: optional double heading = 6;
   */
  heading: number;

  /**
   * *
   * This denotes the horizontal component of the subject's current velocity specified in metres per
   * second. If this is not supported the value is expected to be null. Otherwise, the number must
   * be a non-negative real number.
   *
   * @generated from field: optional double speed = 7;
   */
  speed: number;
};

/**
 * Describes the message squareup.common.location.Coordinates.
 * Use `create(CoordinatesSchema)` to create a new message.
 */
export const CoordinatesSchema: GenMessage<Coordinates> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 1);

/**
 * * Deprecated. Use GlobalAddress. 
 *
 * @generated from message squareup.common.location.Address
 * @deprecated
 */
export type Address = Message<"squareup.common.location.Address"> & {
  /**
   * @generated from field: optional string street_1 = 1 [deprecated = true];
   * @deprecated
   */
  street1: string;

  /**
   * @generated from field: optional string street_2 = 2 [deprecated = true];
   * @deprecated
   */
  street2: string;

  /**
   * @generated from field: optional string city = 3 [deprecated = true];
   * @deprecated
   */
  city: string;

  /**
   * @generated from field: optional string state_province = 4 [deprecated = true];
   * @deprecated
   */
  stateProvince: string;

  /**
   * @generated from field: optional string postal_code = 5 [deprecated = true];
   * @deprecated
   */
  postalCode: string;

  /**
   * @generated from field: optional squareup.common.countries.Country country_code = 6 [deprecated = true];
   * @deprecated
   */
  countryCode: Country;
};

/**
 * Describes the message squareup.common.location.Address.
 * Use `create(AddressSchema)` to create a new message.
 * @deprecated
 */
export const AddressSchema: GenMessage<Address> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 2);

/**
 * *
 * Full documentation can be found here:
 * https://coda.io/d/Multi-Seller-Document-Hub_ds0w_lkE3Tz/Global-Address_suygD#_lumaO
 *
 * *WARNING** - There are MANY deprecated fields in this proto!
 * Please DO NOT USE these deprecated fields.
 * We recommend turning on "Hide Deprecated Fields" when viewing this in go/proto.
 *
 * @generated from message squareup.common.location.GlobalAddress
 */
export type GlobalAddress = Message<"squareup.common.location.GlobalAddress"> & {
  /**
   * *
   * Fields that start with address_line provide the address's most specific details,
   * like street number, street name, and building name.
   * They do not provide less specific details like city, state/province, or country.
   * These details are provided in other fields.
   *
   * @generated from field: optional string address_line_1 = 1;
   */
  addressLine1: string;

  /**
   * @generated from field: optional string address_line_2 = 2;
   */
  addressLine2: string;

  /**
   * @generated from field: optional string address_line_3 = 3;
   */
  addressLine3: string;

  /**
   * *
   * An incorporated city or town political entity.
   *
   * @generated from field: optional string locality = 6;
   */
  locality: string;

  /**
   * *
   * A first-order civil entity below a locality.
   *
   * @generated from field: optional string sublocality = 7;
   */
  sublocality: string;

  /**
   * *
   * A first-order civil entity below the country level.
   * Within the United States, these administrative levels are states.
   * Not all nations exhibit these administrative levels.
   * In most cases, administrative_area_level_1 short names will closely match ISO 3166-2
   * subdivisions and other widely circulated lists
   *
   * @generated from field: optional string administrative_district_level_1 = 13;
   */
  administrativeDistrictLevel1: string;

  /**
   * *
   * The postal code as used to address postal mail within the country
   *
   * @generated from field: optional string postal_code = 16;
   */
  postalCode: string;

  /**
   * *
   * The address's country
   *
   * @generated from field: optional squareup.common.countries.Country country_code = 17;
   */
  countryCode: Country;

  /**
   * * The script this address is written in - Used mostly for JP addresses 
   *
   * @generated from field: optional squareup.common.script.Script script = 20;
   */
  script: Script;

  /**
   * * Contains alternate formats of the existing address fields (e.g. ISO codes) 
   *
   * @generated from field: optional squareup.common.location.GlobalAddress.AlternateFormats alternate_formats = 21;
   */
  alternateFormats?: GlobalAddress_AlternateFormats;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string address_line_4 = 4 [deprecated = true];
   * @deprecated
   */
  addressLine4: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string address_line_5 = 5 [deprecated = true];
   * @deprecated
   */
  addressLine5: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string sublocality_1 = 8 [deprecated = true];
   * @deprecated
   */
  sublocality1: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string sublocality_2 = 9 [deprecated = true];
   * @deprecated
   */
  sublocality2: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string sublocality_3 = 10 [deprecated = true];
   * @deprecated
   */
  sublocality3: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string sublocality_4 = 11 [deprecated = true];
   * @deprecated
   */
  sublocality4: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string sublocality_5 = 12 [deprecated = true];
   * @deprecated
   */
  sublocality5: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string administrative_district_level_2 = 14 [deprecated = true];
   * @deprecated
   */
  administrativeDistrictLevel2: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string administrative_district_level_3 = 15 [deprecated = true];
   * @deprecated
   */
  administrativeDistrictLevel3: string;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional squareup.common.location.Coordinates address_coordinates = 18 [deprecated = true];
   * @deprecated
   */
  addressCoordinates?: Coordinates;

  /**
   * DEPRECATED - DO NOT USE
   *
   * @generated from field: optional string neighborhood = 19 [deprecated = true];
   * @deprecated
   */
  neighborhood: string;
};

/**
 * Describes the message squareup.common.location.GlobalAddress.
 * Use `create(GlobalAddressSchema)` to create a new message.
 */
export const GlobalAddressSchema: GenMessage<GlobalAddress> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 3);

/**
 * @generated from message squareup.common.location.GlobalAddress.AlternateFormats
 */
export type GlobalAddress_AlternateFormats = Message<"squareup.common.location.GlobalAddress.AlternateFormats"> & {
  /**
   * * ISO-3166-2 Subdivision Code (e.g. JP-14, US-CA, GB-LND) 
   *
   * @generated from field: optional string country_subdivision_code = 1;
   */
  countrySubdivisionCode: string;
};

/**
 * Describes the message squareup.common.location.GlobalAddress.AlternateFormats.
 * Use `create(GlobalAddress_AlternateFormatsSchema)` to create a new message.
 */
export const GlobalAddress_AlternateFormatsSchema: GenMessage<GlobalAddress_AlternateFormats> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 3, 0);

/**
 * @generated from message squareup.common.location.Phone
 */
export type Phone = Message<"squareup.common.location.Phone"> & {
  /**
   * *
   * Based on ITU-T E.123 / E.164 recommendations
   * http://www.itu.int/rec/T-REC-E.123-200102-I/en
   * http://www.itu.int/rec/T-REC-E.164/en
   * e.g. "+1" in the US.
   *
   * @generated from field: optional string calling_code = 1;
   */
  callingCode: string;

  /**
   * *
   * Number, including area code, but not country code (without the leading 1
   * in the US). e.g. "4155550000".
   *
   * @generated from field: optional string number = 2;
   */
  number: string;
};

/**
 * Describes the message squareup.common.location.Phone.
 * Use `create(PhoneSchema)` to create a new message.
 */
export const PhoneSchema: GenMessage<Phone> = /*@__PURE__*/
  messageDesc(file_squareup_common_location, 4);

